export default "__VITE_ASSET__EjeU5kKb__"